<template>
  <w-settings-detail :title="title" :menu="menu" default-active-menu="WLogAlarm" @change="onChangeMenu">
    <component slot="activeView" :is="currentView"></component>
  </w-settings-detail>
</template>

<script>
import WSettingsDetail from '@/components/template/SettingsDetail';
import WLogAlarm from './LogAlarmSetting';
import WBaseLineRule from './LogBaselineSetting';

export default {
  name: 'WLogAlarmSettings',
  components: {
    WSettingsDetail,
    WLogAlarm,
    WBaseLineRule,
  },
  props: {
    title: String,
  },
  data() {
    return {
      currentView: 'WLogAlarm',
      menu: [
        {
          id: 'WLogAlarm',
          name: '로그 알람',
          active: true,
        },
        {
          id: 'WBaseLineRule',
          name: '베이스라인 정책',
          active: false,
        },
      ],
    };
  },
  methods: {
    onChangeMenu(data) {
      this.currentView = data;
    },
  },
};
</script>

<style scoped>
.sideSettingMenu{
  background-color: #D8D8D8;
}
.h100 {
  height:100%;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/index.vue